
import { defineComponent, ref, computed } from 'vue';
import VueQrcode from 'vue-qrcode';
import SimpleModal from '@/components/molecules/SimpleModal.vue';

export default defineComponent({
  name: 'RankCard',
  components: {
    VueQrcode,
    SimpleModal,
  },
  props: {
    rank: {
      type: Object,
      required: true,
    },
    customerId: {
      type: String,
      required: true,
    },
    qrCodeValue: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const rankImageUrl = computed(() => props.rank.settings.retail.imageUrl);
    const showQrModal = ref(false);

    const openModal = () => {
      showQrModal.value = true;
    };
    const closeModal = () => {
      showQrModal.value = false;
    };

    return {
      rankImageUrl,
      showQrModal,
      openModal,
      closeModal,
    };
  },
});
